import { ComparerContext } from '@/context/ComparerContext';
import { useContext } from 'react';

export const useComparer = () => useContext(ComparerContext);
